$(document).ready(function() {
    // Gallery Slider Pager

    var $galleryPager = $('.paging-info');
    var $gallery = $('.gallery-slider');

    $gallery.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $galleryPager.text(i + ' of ' + slick.slideCount);
    });

    // Gallery Slider

    $('.gallery-slider').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        infinite: false,
        autoplay: false,
        pauseOnHover: false,
        lazyLoad: 'ondemand',
        arrows: true,
        nextArrow: $('.gallery-next'),
        prevArrow: $('.gallery-prev')
    });

    // Enables slider width to be determined on load
    $('a.toggle-gallery-modal').click(function() {
        // Set slide clicked on
        var initialSlide = $(this).attr('data-number');

        $('.generic-gallery-modal').addClass('reset-modal');
        $('.gallery-slider').slick('refresh');
        // set initial slide to the slide clicked on
        $('.gallery-slider').slick('slickGoTo', parseInt(initialSlide - 1));
    });

    // Hide Modal once closed
    $('.generic-gallery-modal .uk-close').click(function() {
        $('.generic-gallery-modal').removeClass('reset-modal');
    });
});
